export function productPath(product) {
  return `/product/${product.slug || product.id}`;
}